module.exports = __webpack_public_path__ + "img/scene4.9f3f5bda.jpg";